import { StrictMode } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SSRProvider, getClientSSRData } from './ssr/SSRContext';
import './index.css';

const container = document.getElementById('root')!;

// Check if the server rendered the page (data-server-rendered="true" on #root)
const isServerRendered = container.dataset.serverRendered === 'true';

// Get SSR data injected by the server (window.__SSR_DATA__)
const ssrData = getClientSSRData();

if (isServerRendered) {
  // Hydrate: the server already rendered HTML, we just attach event handlers
  hydrateRoot(
    container,
    <StrictMode>
      <SSRProvider value={ssrData}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SSRProvider>
    </StrictMode>
  );
} else {
  // Fallback: full client-side render (dev without SSR, or if SSR failed)
  createRoot(container).render(
    <StrictMode>
      <SSRProvider value={null}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SSRProvider>
    </StrictMode>
  );
}
